module.exports = __webpack_public_path__ + "img/hest_maddie.34af6880.jpg";